"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var costMerits_1 = require("../costMerits");
var costMeritsConfig = {
    wherewego: {
        costMerits: costMerits_1.wwgCostMerits,
        costMeritsOptions: costMerits_1.wwgCostMeritOptions,
        costMeritsIconsMapping: costMerits_1.wwgCostMeritsIconMapping,
    },
    skillup: {
        costMerits: costMerits_1.skillUpCostMerits,
        costMeritsOptions: costMerits_1.skillUpCostsMeritOptions,
        costMeritsIconsMapping: costMerits_1.skillupCostMeritsIconMapping,
    },
};
exports.default = costMeritsConfig;
